import { ReactNode } from "react";

import { ApiPageResponse } from "@sso/types";
import { Flex } from "@sso/ui/FlexBox";
import { Typography } from "@sso/ui/Typography";

interface TableLayoutWrapperProps {
  error: unknown;
  data: ApiPageResponse<unknown> | undefined;
  children: ReactNode;
}

export const TableLayoutWrapper = ({ error, data, children }: TableLayoutWrapperProps) => {
  if (error || data?.resources.length === 0) {
    return (
      <Flex height="100%" width="100%">
        <Typography>
          {error ? "Something went wrong. Please try again." : "There are no records to display."}
        </Typography>
      </Flex>
    );
  }
  return <>{children}</>;
};
